import { render, staticRenderFns } from "./newslistPage.vue?vue&type=template&id=74f6c5cc&"
import script from "./newslistPage.vue?vue&type=script&lang=js&"
export * from "./newslistPage.vue?vue&type=script&lang=js&"
import style0 from "./newslistPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports